export const Board ={
    dashboard:["MallFootFall","MallOccupancy","VehicleOccupancy","VehicleCount","AgeGender"],
    pages:["MallAnalytics","Facial Recognition","ANPR","HeatMaps","FloorWise","AnchorTeanuts","FoodCourt","Reports"]
}
export const Emt ={
    dashboard:["MallFootFall","MallOccupancy","VehicleOccupancy","VehicleCount","AgeGender"],
    pages:["MallAnalytics","Facial Recognition","ANPR","HeatMaps","FloorWise","AnchorTeanuts","FoodCourt","Reports"]
}
export const Leasing ={
    dashboard:["MallFootFall","AgeGender"],
    pages:["MallAnalytics","HeatMaps","FloorWise","AnchorTeanuts","FoodCourt","Reports"]
}
export const Marketing ={
    dashboard:["MallFootFall","MallOccupancy","VehicleCount","AgeGender"],
    pages:["MallAnalytics","Facial Recognition","ANPR","HeatMaps","FloorWise","AnchorTeanuts","FoodCourt","Reports"]
}
export const Security ={
    dashboard:["MallFootFall","MallOccupancy","VehicleOccupancy","VehicleCount"],
    pages:["ANPR","FloorWise","AnchorTeanuts","FoodCourt","Reports"]
}
export const permissions ={
    dashboard:["MallFootFall","MallOccupancy","VehicleOccupancy","VehicleCount","AgeGender"],
    pages:["MallAnalytics","Facial Recognition","ANPR","HeatMaps","FloorWise","AnchorTeanuts","FoodCourt","Reports","Role","User"]
}
export const AllPermission=["MallFootFall","MallOccupancy","VehicleOccupancy","VehicleCount","AgeGender","MallAnalytics","Facial Recognition","ANPR","HeatMaps","FloorWise","AnchorTeanuts","FoodCourt","Reports","Role","User"]
export const reportUser=["Facial Recognition"]
export const Permissions =["Person Counting","Fr","Fr In/OUT","Day Wise Report","Month Wise Report","Role","User","Missing People","Add Employees(Fr)","Add Attendance"];
export const PermissionsWithUrl ={"Person Counting":"/dashboard","Fr":"/fr","Fr In/OUT":"/in-out","Day Wise Report":"/daily-wise-report","Month Wise Report":"/monthly-wise-report","Role":"/role","User":"/user","Missing People":"/missing-people","Add Employees(Fr)":"","Add Attendance":""};

